module.exports = __webpack_public_path__ + "img/95.02abedf8.svg";